import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import localeAR from '@angular/common/locales/ar'; // Arabic
import localeBE from '@angular/common/locales/be'; // Belarus
import localeBG from '@angular/common/locales/bg'; // Bulgarien
import localeBS from '@angular/common/locales/bs'; // Bosnien
import localeCA from '@angular/common/locales/ca'; // Catalan
import localeCS from '@angular/common/locales/cs';
import localeDA from '@angular/common/locales/da'; // Danish
import localeDe from '@angular/common/locales/de';
import localeDeAT from '@angular/common/locales/de-AT';
import localeDeBE from '@angular/common/locales/de-BE';
import localeDeCH from '@angular/common/locales/de-CH';
import localeDeIT from '@angular/common/locales/de-IT';
import localeDeLI from '@angular/common/locales/de-LI';
import localeDeLU from '@angular/common/locales/de-LU';
import localeEL from '@angular/common/locales/el'; // Greek
import localeES from '@angular/common/locales/es'; // Spanish
import localeFR from '@angular/common/locales/fr';
import localeET from '@angular/common/locales/et'; // Estonian
import localeFI from '@angular/common/locales/fi'; // Finnish
import localeHR from '@angular/common/locales/hr'; // Croatian
import localeHU from '@angular/common/locales/hu';
import localeHY from '@angular/common/locales/hy'; // Armenian
import localeIt from '@angular/common/locales/it';
import localeItCH from '@angular/common/locales/it-CH';
import localeItSM from '@angular/common/locales/it-SM';
import localeItVA from '@angular/common/locales/it-VA';
import localeLT from '@angular/common/locales/lt'; // Lithuanian
import localeLV from '@angular/common/locales/lv'; // Latvian
import localeMK from '@angular/common/locales/mk'; // Macedonian
import localeMT from '@angular/common/locales/mt'; // Maltese
import localeNL from '@angular/common/locales/nl'; // Dutch
import localePL from '@angular/common/locales/pl';
import localePT from '@angular/common/locales/pt'; // Portugese
import localeRM from '@angular/common/locales/rm'; // Romansh
import localeRO from '@angular/common/locales/ro';
import localeRU from '@angular/common/locales/ru'; // Russian
import localeSK from '@angular/common/locales/sk';
import localeSL from '@angular/common/locales/sl';
import localeSQ from '@angular/common/locales/sq'; // Albanian
import localeSR from '@angular/common/locales/sr';
import localeSRCyrl from '@angular/common/locales/sr-Cyrl';
import localeSRLatn from '@angular/common/locales/sr-Latn';
import localeSV from '@angular/common/locales/sv'; // Swedish
import localeTR from '@angular/common/locales/tr'; // Türkisch
import localeUK from '@angular/common/locales/uk'; // Ukrain
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataListModule } from './_components/data-list/data-list.module';
import { PinSelectModalModule } from './_components/pin-select-modal/pin-select-modal.module';
import { PinSelectModule } from './_components/pin-select/pin-select.module';
import { PopoverJobSectionInstanceDynFormComponentModule } from './_components/popover-jobsection-instance-dyn-form/popover-jobsection-instance-dyn-form.module';
import { PopoverMultiInstanceDynFormComponentModule } from './_components/popover-multi-instance-dyn-form/popover-multi-instance-dyn-form.module';
import { ModalMultiInstanceDynFormModule } from './_components/modal-multi-instance-dyn-form/modal-multi-instance-dyn-form.module';
import { ServicejobSearchResultDetailBranchModule } from './_components/servicejob-search-result-detail-branch/servicejob-search-result-detail-branch.module';
import { ServicejobSearchResultDetailSJobModule } from './_components/servicejob-search-result-detail-sjob/servicejob-search-result-detail-sjob.module';
import { ServicejobSearchResultModule } from './_components/servicejob-search-result/servicejob-search-result.module';
import { ServicejobSearchModule } from './_components/servicejob-search/servicejob-search.module';
import { SignatureModule } from './_components/signature/signature.module';
import { GenericRemoteActionPageModule } from './_pages/generic-remote-action/generic-remote-action.module';
import { PlanMarkerDocModule } from './_pages/plan-marker-doc/plan-marker-doc.module';
import { DocumentViewerModule } from './_pages/plan-marker/document-viewer.module';
import { PlanMarkerModule } from './_pages/plan-marker/plan-marker.module';
import { TokenIdPageModule } from './_pages/token-id/token-id.module';
import { ActionInterpreterModule } from './_services/action-interpreter/action-interpreter.module';
import { ActionInterpreterService } from './_services/action-interpreter/action-interpreter.service';
import { GeneralActionInterpreterService } from './_services/action-interpreter/general-action-interpreter/general-action-interpreter.service';
import { ActivityTypesModule } from './_services/activity-types/activity-types.module';
import { AppParameterModule } from './_services/app-parameter/app-parameter.module';
import { AppServiceModule } from './_services/app-service/app-service.module';
import { ArchivesModule } from './_services/archives/archives.module';
import { AuthenticationService } from './_services/authentication/authentication.service';
import { OauthAuthenticationService } from './_services/authentication/oauth-authentication/oauth-authentication.service';
import { BadgesModule } from './_services/badges/badges.module';
import { BillOfQuantitiesPositionsModule } from './_services/bill-of-quantities-positions/bill-of-quantities-positions.module';
import { BillOfQuantitiesModule } from './_services/bill-of-quantities/bill-of-quantities.module';
import { BranchTypesModule } from './_services/branch-types/branch-types.module';
import { BranchesModule } from './_services/branches/branches.module';
import { PersonsModule } from './_services/persons/persons.module';
import { BranchFunctionGroupsModule } from './_services/branch-function-groups/branch-function-groups.module';
import { EmployeeFunctionGroupsModule } from './_services/employee-function-groups/employee-function-groups.module';
import { CargoItemTypesModule } from './_services/cargo-item-types/cargo-item-types.module';
import { CargoItemsModule } from './_services/cargo-item/cargo-item.module';
import { CarsModule } from './_services/cars/cars.module';
import { ClientStateModule } from './_services/client-state/client-state.module';
import { CommunicationModule } from './_services/communication/communication.module';
import { CredentialsModule } from './_services/credentials/credentials.module';
import { DataTasksModule } from './_services/data-tasks/data-tasks.module';
import { DynFormParserModule } from './_services/dyn-form-parser/dyn-form-parser.module';
import { DynFormsModule } from './_services/dyn-forms/dyn-forms.module';
import { EmpJobMappingsModule } from './_services/emp-job-mapping/emp-job-mapping.module';
import { EmployeeModule } from './_services/employee/employee.module';
import { EquipmentsModule } from './_services/equipments/equipments.module';
import { ExtFilesModule } from './_services/ext-files/ext-files.module';
import { FileManagerModule } from './_services/file-manager/file-manager.module';
import { ImageModule } from './_services/image/image.module';
import { InitializeModule } from './_services/initialize/initialize.module';
import { InitializeScreenModule } from './_components/initialize-screen/initialize-screen.module';
import { JobSectionsModule } from './_services/job-section/job-section.module';
import { LocalStatusModule } from './_services/local-status/local-status.module';
import { LocationModule } from './_services/location/location.module';
import { LoggingModule } from './_services/logging/logging.module';
import { LoggingService } from './_services/logging/logic/logging.service';
import { LogicModule } from './_services/logic/logic.module';
import { MaskDefinitionModule } from './_services/mask-definition/mask-definition.module';
import { MaterialsModule } from './_services/materials/materials.module';
import { MenuModule } from './_services/menu/menu.module';
import { MobileOAuthStorageService } from './_services/mobile-oauth-storage/mobile-oauth-storage.service';
import { NetworkModule } from './_services/network/network.module';
import { OrderItemsModule } from './_services/order-item/order-item.module';
import { PinTypesModule } from './_services/pin-types/pin-types.module';
import { PinsModule } from './_services/pins/pins.module';
import { ProcessStepsModule } from './_services/process-steps/process-steps.module';
import { ProjectContactDirectoryModule } from './_services/project-contact-directory/project-contact-directory.module';
import { PushNotificationsModule } from './_services/push-notifications/push-notifications.module';
import { ReasonsModule } from './_services/reasons/reasons.module';
import { RemoteActionModule } from './_services/remote-action/remote-action.module';
import { ResetterModule } from './_services/resetter/resetter.module';
import { ResourceManagerModule } from './_services/resource-manager/resource-manager.module';
import { ServicejobsModule } from './_services/servicejobs/servicejobs.module';
import { StockModule } from './_services/stock/stock.module';
import { SyncModule } from './_services/sync/sync.module';
import { TagStatesModule } from './_services/tag-states/tag-states.module';
import { TagTemplatesElementsModule } from './_services/tag-templates-elements/tag-templates-elements.module';
import { TagTemplatesModule } from './_services/tag-templates/tag-templates.module';
import { TourStopsModule } from './_services/tour-stop/tour-stop.module';
import { TourModule } from './_services/tour/tour.module';
import { VisibilityModule } from './_services/visibility/visibility.module';
import { WorktypesModule } from './_services/worktypes/worktypes.module';
import { ImsErrorHandler } from './_util/ims-error-handler';
import { UndefinedMissingTranslationHandler } from './_util/undefined-missing-translation-handler';
import { PreferencesModule } from './_services/preferences/preferences.module';
import { ObjectResolverModule } from './_services/object-resolver/object-resolver.module';
import { SQLiteService } from './_services/persistence/db-persistence/sqlite.service';
import { BarcodeModule } from './_services/barcode/barcode.module';
import { PostProcessorModule } from './_services/post-processors/post-processor.module';
import { PostProcessorService } from './_services/post-processors/post-processors.service';
import { GeneralPostProcessorService } from './_services/post-processors/general-post-processor/general-post-processor.service';
import { UpdateModeObjectModule } from './_services/update-model-object/update-model-object.module';
import { DbPersistenceModule } from './_services/persistence/db-persistence/db-persistence.module';
import { DeficiencyTicketsModule } from './_services/deficiency-ticket/deficiency-tickets.module';
import { DeficiencyTicketWatchersModule } from './_services/deficiency-ticket-watchers/deficiency-ticket-watchers.module';
import { ActivityConfirmationsModule } from './_services/activity-confirmations/activity-confirmations.module';
import { LBSErrorHandlerModule } from './_services/error-handler/error-handler.module';
import { CUSTOM_ELEMENTS_SCHEMA, isDevMode } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { PeripheralsServiceModule } from './_services/peripherals/peripherals.service.module';
import { PeripheralConnectionEstablishModalModule } from './_components/peripheral-connection-establish-modal/peripheral-connection-establish-modal.module';
import { PeripheralGallerySelectModalModule } from './_pages/peripheral-gallery-select-modal/peripheral-gallery-select-modal.module';
import { EventModule } from './_services/event/event.module';
import { BarcodeParserModule } from './_services/barcode-parser/barcode-parser.module';
import { MapModule } from './_services/map/map.module';
import { RequiredUserActionValidatorModule } from './_services/user-action-validator/required-user-action-validator.module';
import { RequiredUserActionsModule } from './_services/required-user-actions/required-user-actions.module';
import { TranslationsModule } from './_services/translations/translations.module';
import { HapticsModule } from './_services/haptics/haptics.module';
import { GPSTrackModule } from './_services/gps-track/gps-track.module';
import { ObjectDetailPageModule } from './_pages/object-detail/object-detail.module';
import { MaterialDemandInfosServiceModule } from './_services/materialdemandinfo/materialdemandinfo.service.module';
import { NavigationModule } from './_services/navigation/navigation.module';
import { CustomerLanguageResolverModule } from './_services/customer-language-resolver/customer-language-resolver.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MessagesModule } from './_services/message/message.module';
import { AppTasksModule } from './_services/app-tasks/app-tasks.module';
import { FunctionGroupsModule } from './_services/function-group/function-groups.module';
import { APIModule } from './_services/api/api.module';
import { ObjectIdLabelLogicService } from './_services/object-id-label/logic/object-id-label/object-id-label-logic.service';
import { ObjectIdLabelModule } from './_services/object-id-label/object-id-label.module';
import { CellphonesModule } from './_services/cellphones/cellphones.module';

registerLocaleData(localeDe);
registerLocaleData(localeDeAT);
registerLocaleData(localeDeBE);
registerLocaleData(localeDeCH);
registerLocaleData(localeDeIT);
registerLocaleData(localeDeLI);
registerLocaleData(localeDeLU);
registerLocaleData(localeIt);
registerLocaleData(localeItCH);
registerLocaleData(localeItSM);
registerLocaleData(localeItVA);
registerLocaleData(localePL);
registerLocaleData(localeCS);
registerLocaleData(localeSK);
registerLocaleData(localeSL);
registerLocaleData(localeSR);
registerLocaleData(localeHU);
registerLocaleData(localeRO);
registerLocaleData(localeSRCyrl);
registerLocaleData(localeSRLatn);
registerLocaleData(localeSQ);
registerLocaleData(localeAR);
registerLocaleData(localeHY);
registerLocaleData(localeBE);
registerLocaleData(localeBS);
registerLocaleData(localeBG);
registerLocaleData(localeCA);
registerLocaleData(localeHR);
registerLocaleData(localeDA);
registerLocaleData(localeNL);
registerLocaleData(localeET);
registerLocaleData(localeFI);
registerLocaleData(localeEL);
registerLocaleData(localeLV);
registerLocaleData(localeLT);
registerLocaleData(localeMK);
registerLocaleData(localeMT);
registerLocaleData(localePT);
registerLocaleData(localeRM);
registerLocaleData(localeRU);
registerLocaleData(localeES);
registerLocaleData(localeFR);
registerLocaleData(localeSV);
registerLocaleData(localeTR);
registerLocaleData(localeUK);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OAuthModule.forRoot(),
    IonicModule.forRoot(),
    DbPersistenceModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: UndefinedMissingTranslationHandler,
        deps: [LoggingService],
      },
    }),
    AppRoutingModule,
    AutocompleteLibModule,
    // Feature Moduels
    ObjectResolverModule,
    InitializeModule,
    InitializeScreenModule,
    HapticsModule,
    VisibilityModule,
    RequiredUserActionValidatorModule,
    BarcodeModule,
    PeripheralConnectionEstablishModalModule,
    PeripheralGallerySelectModalModule,
    PlanMarkerDocModule,
    PlanMarkerModule,
    DocumentViewerModule,
    PinSelectModalModule,
    PinSelectModule,
    NetworkModule,
    ActionInterpreterModule,
    LBSErrorHandlerModule,
    SignatureModule,
    BadgesModule,
    DataTasksModule,
    FileManagerModule,
    AppParameterModule,
    EmployeeModule,
    WorktypesModule,
    ActivityTypesModule,
    ProcessStepsModule,
    FunctionGroupsModule,
    BranchesModule,
    PersonsModule,
    BranchFunctionGroupsModule,
    EmployeeFunctionGroupsModule,
    BranchTypesModule,
    CargoItemTypesModule,
    ServicejobsModule,
    AppTasksModule,
    ArchivesModule,
    ClientStateModule,
    MenuModule,
    MaskDefinitionModule,
    RequiredUserActionsModule,
    TranslationsModule,
    GPSTrackModule,
    LoggingModule,
    LocalStatusModule,
    CommunicationModule,
    RemoteActionModule,
    PushNotificationsModule,
    ResourceManagerModule,
    AppServiceModule,
    GenericRemoteActionPageModule,
    LocationModule,
    ResetterModule,
    SyncModule,
    CredentialsModule,
    ImageModule,
    APIModule,
    MapModule,
    EventModule,
    BarcodeParserModule,
    PeripheralsServiceModule,
    DynFormsModule,
    DynFormParserModule,
    ExtFilesModule,
    PinsModule,
    PinTypesModule,
    ProjectContactDirectoryModule,
    DeficiencyTicketsModule,
    DeficiencyTicketWatchersModule,
    ActivityConfirmationsModule,
    ServicejobSearchModule,
    EmpJobMappingsModule,
    ServicejobSearchResultModule,
    ServicejobSearchResultDetailSJobModule,
    ServicejobSearchResultDetailBranchModule,
    EquipmentsModule,
    TokenIdPageModule,
    MaterialsModule,
    DataListModule,
    PopoverMultiInstanceDynFormComponentModule,
    ModalMultiInstanceDynFormModule,
    PopoverJobSectionInstanceDynFormComponentModule,
    BillOfQuantitiesModule,
    BillOfQuantitiesPositionsModule,
    TourModule,
    TourStopsModule,
    CargoItemsModule,
    OrderItemsModule,
    JobSectionsModule,
    MaterialDemandInfosServiceModule,
    ObjectIdLabelModule,
    CellphonesModule,
    TagTemplatesModule,
    TagTemplatesElementsModule,
    StockModule,
    ReasonsModule,
    CarsModule,
    TagStatesModule,
    LogicModule,
    PreferencesModule,
    PostProcessorModule,
    UpdateModeObjectModule,
    ObjectDetailPageModule,
    NavigationModule,
    CustomerLanguageResolverModule,
    MessagesModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      // PWA only. On native the assets are already local, so the service worker buys no
      // offline capability - it only adds a second copy of the app that outlives an app
      // update: its CacheStorage lives in the WebView data dir, not in the APK. That is
      // how a device ran the JS of build 2026082700 while reporting 2026090100 (the
      // native build number comes from App.getInfo(), the code from the cache).
      //
      // Android only in practice: with server.androidScheme 'http' the app is served from
      // http://localhost, a secure context where a service worker registers. iOS uses the
      // capacitor:// scheme, which has no service worker support - which is exactly why
      // the two platforms drifted apart instead of failing together.
      //
      // Installs where the old worker is already in control are not reached by this - they
      // never load this file. scripts/neutralize-native-service-worker.sh handles those.
      enabled: !isDevMode() && !Capacitor.isNativePlatform(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    provideHttpClient(),
    SQLiteService,
    { provide: ErrorHandler, useClass: ImsErrorHandler },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: AuthenticationService, useClass: OauthAuthenticationService },
    {
      provide: ActionInterpreterService,
      useClass: GeneralActionInterpreterService,
    },
    { provide: PostProcessorService, useClass: GeneralPostProcessorService },
    MobileOAuthStorageService,
    { provide: OAuthStorage, useExisting: MobileOAuthStorageService },
    // Locale for datepipe to format correct datestrings
    DatePipe,
    {
      provide: LOCALE_ID,
      deps: [TranslateService],
      useFactory: (translateService) =>
        translateService.getBrowserCultureLang(), //returns locale string
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
